import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal, Tabs, Tab, Alert } from 'react-bootstrap';
import DataTable from '../../components/datatable/DataTable';
import Constants from '../../config/constants';
import ProjectMemberInvitationForm from '../../components/member/ProjectMemberInvitationForm';
import PendingProjectInvitationTable from '../../components/member/PendingProjectInvitationTable';
import renderDeleteConfirmation from '../../components/member/DeleteConfirmation';

import { COLUMN_STYLE, getColumnStyle } from '../../components/datatable/util';
import { defaultRejectHandler, stringifyErrorMessage } from '../../utils/utility';

import { createProjectInvitation } from '../../redux/project_inv/project_inv_actions';
import {
  listProjectMember,
  removeMember,
} from '../../redux/project_member/project_member_actions';



class MemberInvitationModal extends React.Component {
  constructor(props) {
    super(props);

    this.search = {
      pageSize: Constants.DATA_TABLE_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
      isShowInvitedInfo: false,
      invitedAccount: null,
      isShowMemberDelConfirm: false,
      selectedMember: null,
      isInvited: false,
    };

    this.inviteMemberRef = null;
    const { t } = props;
    this.columns = [
      {
        Header: () => <b>{t('username')}</b>,
        accessor: 'username',
        ...getColumnStyle(COLUMN_STYLE.text),
      },
      {
        id: 'invitee_name_id',
        Header: () => <b>{t('name')}</b>,
        accessor: item => `${item.first_name} ${item.last_name}`,
        ...getColumnStyle(COLUMN_STYLE.text),
      },
    ];
  }

  updateSortFilter(search, state) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.search = search;

    this.props.listMember(
      this.search.pageSize,
      this.search.page,
      this.search.sorted,
      this.search.search,
      this.props.project.id,
    );
  }

  shouldShowMemberDeleteButton(member) {
    const { me, project } = this.props;
    return (project.is_owner && member.username !== me.username) || (!project.is_owner && member.username === me.username);
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.isRemoving && (this.props.isRemoving !== nextProps.isRemoving)) {
      if (!nextProps.errorMessage) {
        this.setState({ isShowMemberDelConfirm: false });
      } else {
        this.setState({ isShowMemberDelConfirm: true, removeMemberErrorMessage: nextProps.errorMessage });
      }
    }

    if (!nextProps.isInvCreating && nextProps.isInvCreating !== this.props.isInvCreating && !nextProps.invErrorMessage) {
      this.setState({
        invitedAccount: nextProps.invitee,
        isShowInvitedInfo: true,
        isDirty: false,
        isInvited: true,
      });
      this.inviteMemberRef.getWrappedInstance().getWrappedInstance().reset();
    }

    if(nextProps.isFinding && nextProps.isFinding !== this.props.isFinding){
      this.setState({ isInvited: false })
    }
    
  }

  onSaveHandler() {
    const editedSubmission = this.inviteMemberRef.getWrappedInstance().getWrappedInstance().getSubmissionData();
    this.props.editSubmission({ ...editedSubmission, id: this.props.submissionDetail.id });
  }

  onSubmitHandler() {
    this.props.createInvitation(this.props.project, this.props.invitee);
  }

  renderInvForm() {
    const {
      isCreating,
      isSubmitting,
      isFinding,
      isValid,
      errorMessage,
      t,
    } = this.props;
    const { isDirty, isShowInvitedInfo, invitedAccount } = this.state;
    const isInProgress = isCreating || isFinding || isSubmitting;
    return (
      <React.Fragment>
        {isShowInvitedInfo && invitedAccount && (
          <Alert onDismiss={() => this.setState({ isShowInvitedInfo: false })}>
            {t('invitation has been sent to')} <strong>{invitedAccount.username}</strong>
          </Alert>
        )}
        <ProjectMemberInvitationForm
          onValid={isValid => this.setState({ isValid })}
          onDirty={isDirty => this.setState({ isDirty })}
          onSubmittable={isSubmittable => this.setState({ isSubmittable })}
          fieldErrors={errorMessage}
          ref={ref => (this.inviteMemberRef = ref)}
          t={t}
          onSubmit={() => !isInProgress && this.props.isValid && !this.state.isInvited && !this.props.isInvCreating && this.onSubmitHandler() }
        />
        <div style={{ display: 'flex', flexFlow: 'column' }}>
          <div style={{ alignSelf: 'flex-end' }}>
            <Button
              id="project-member-invite"
              style={{ width: 140 }}
              bsStyle="success"
              disabled={isInProgress || !isDirty || isFinding || !isValid}
              onClick={() => this.onSubmitHandler()}
            >
              {isSubmitting ? `${t('inviting')}...` : t('invite')}
            </Button>
          </div>
        </div>
      </React.Fragment>
    );
  }

  renderErrorMessage(errorMessage) {
    if (!errorMessage) return null;
    return (
      <Alert
        bsStyle="danger"
        style={{ 'white-space': 'pre' }}
        onDismiss={() => this.setState({ removeMemberErrorMessage: null })}
      >
        {errorMessage}
      </Alert>
    );
  }

  renderMembers() {
    const {
      members,
      project,
      filteredCount,
      isLoading,
      isDeleting,
      errorMessage,
      listMember,
      removeMember,
      t,
    } = this.props;

    const { isShowMemberDelConfirm, selectedMember: member, removeMemberErrorMessage } = this.state;
    return (
      <React.Fragment>
        {isShowMemberDelConfirm &&
          renderDeleteConfirmation(
            member.username,
            isDeleting,
            () => removeMember(project.id, member.id),
            () => this.setState({ isShowMemberDelConfirm: false }),
            t,
          )}
        {removeMemberErrorMessage && this.renderErrorMessage(stringifyErrorMessage(removeMemberErrorMessage))}
        <DataTable
          columns={this.columns}
          data={members}
          onActionDelete={item => this.setState({ isShowMemberDelConfirm: true, selectedMember: item.original })}
          shouldShowActionMenu={(actionName, row) => actionName === DataTable.ACTION_DELETE ? this.shouldShowMemberDeleteButton(row.original) : true}
          filteredCount={filteredCount}
          isLoading={isLoading}
          onFetchData={state => this.updateSortFilter(this.search.search, state)}
        />
      </React.Fragment>
    );
  }

  render() {
    const {
      isCreating,
      isSubmitting,
      isFinding,
      isValid,
      isRemoving,
      isInvCreating,
      invErrorMessage,
      errorMessage,
      project,
      listInvitation,
      createInvitation,
      listMember,
      removeMember,
      me,
      t,
      ...newProps
    } = this.props;

    return (
      <Modal
        {...newProps}
        backdrop="static"
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('members')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Tabs id="members">
            <Tab eventKey={1} title={t('members')}>{this.renderMembers()}</Tab>
            {project.is_owner && <Tab eventKey={2} title={t('invite member')}>{this.renderInvForm()}</Tab>}
            {project.is_owner && <Tab eventKey={3} title={t('pending invitations')}><PendingProjectInvitationTable owner={me}/></Tab>}
          </Tabs>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  isFinding: state.profile.isFinding,
  isValid: !!state.profile.account,
  invitee: state.profile.account,
  me: state.profile.profile,
  isInvCreating: state.projectInvitation.isCreating,
  invErrorMessage: state.projectInvitation.errorMessage,
  members: state.projectMember.orderedIds.map(id => state.projectMember.objects[id]),
  isRemoving: state.projectMember.isRemoving,
  errorMessage: state.projectMember.errorMessage,
});

const mapDispatchToProps = (dispatch) => ({
  createInvitation: (project, invitee) => defaultRejectHandler(dispatch(createProjectInvitation(project.id, invitee.id))),
  listMember: (pageSize, page, sorted, search, project_id) => defaultRejectHandler(dispatch(listProjectMember(pageSize, page, sorted, search, project_id))),
  removeMember: (projectId, memberId) => defaultRejectHandler(dispatch(removeMember(projectId, memberId)))
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(MemberInvitationModal),
);



// WEBPACK FOOTER //
// ./src/modal/member/MemberInvitationModal.js